<div class="flex items-center gap-2.5">
  @if (url()) {
    <button type="button" (click)="abrirAmpliada()" aria-label="Ver foto en grande" class="shrink-0">
      <img [src]="url()" [alt]="foto.etiqueta || 'foto del mueble'" class="w-14 h-14 rounded-lg object-cover border border-[var(--border)]" />
    </button>
  }
  <label [attr.for]="'foto-etiqueta-' + foto.id" class="sr-only">Etiqueta de la foto</label>
  <input
    [id]="'foto-etiqueta-' + foto.id"
    [ngModel]="foto.etiqueta"
    (ngModelChange)="alCambiarEtiqueta($event)"
    placeholder="Ej. Detalle, textura…"
    class="flex-1 min-w-0 border border-[var(--border)] rounded-lg px-2.5 py-2 text-[12.5px] bg-[var(--surface)]"
  />
  <button type="button" (click)="eliminar.emit(foto.id)" aria-label="Eliminar foto"
          class="shrink-0 text-[12px] font-bold text-[var(--coral-ink)] px-2 py-1">
    ✕
  </button>
</div>
@if (verAmpliada()) {
  <app-visor-imagen [url]="url()!" [titulo]="foto.etiqueta || 'Foto'" (cerrar)="cerrarAmpliada()" />
}
